import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
var ResultsAuthContext = createContext({
    isAuthenticated: false,
    setAuthenticatedSession: function () { return undefined; },
    clearAuthenticatedSession: function () { return undefined; },
});
export var ResultsAuthContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(undefined), session = _b[0], setSession = _b[1];
    var setAuthenticatedSession = useCallback(function (nextSession) { return setSession(nextSession); }, []);
    var clearAuthenticatedSession = useCallback(function () { return setSession(undefined); }, []);
    var value = useMemo(function () { return ({
        isAuthenticated: Boolean(session),
        userProfile: session === null || session === void 0 ? void 0 : session.userProfile,
        logout: session === null || session === void 0 ? void 0 : session.logout,
        setAuthenticatedSession: setAuthenticatedSession,
        clearAuthenticatedSession: clearAuthenticatedSession,
    }); }, [clearAuthenticatedSession, session, setAuthenticatedSession]);
    return _jsx(ResultsAuthContext.Provider, { value: value, children: children });
};
export var useResultsAuth = function () { return useContext(ResultsAuthContext); };
